'use strict';

const sitemap = {
    /** @type {Object.<string,jQuery>} */
    elements: {
        $ajaxDataContainer: $('div.page')
    },

    init() {
        if (!this.elements.$ajaxDataContainer.length || !this.elements.$ajaxDataContainer.data('page-load-action-url')) {
            return;
        }
        this.pageLoadActionUrl = this.elements.$ajaxDataContainer.data('page-load-action-url');
        this.handleAjaxCalls();
    },

    handleAjaxCalls() {
        $.ajax({
            url: this.pageLoadActionUrl,
            type: 'get',
            dataType: 'json',
            success: (data) => {
                if (data.html) {
                    $('body').append(data.html);
                    $('#inviteDetailsModal').modal('show');
                }
            }
        });
    }
};


module.exports = sitemap;
